<template>
  <div>
    <div ref="modelCourseTop" class="absolute target-top"></div>
    <div v-show="!showMapPanel">
      <div class="top-title border-b border-section_border" id="top-title">
        <h1 class="top-title-heading" v-html="$t('tour_cources_title')"></h1>
      </div>
      <div class="relative z-10">
        <div v-if="course" class="px-4 py-1">
          <course-detail :course="course" :createPlan="false" @openMap="openMap" @closeCourse="closeCourse" />
        </div>
        <!-- <div v-else>
          <course-list :createPlan="false" :areaId="areaId" :areaDetail="areaDetail" :courseId="courseId" @selectCourse="selectCourse" />
        </div> -->
      </div>
      <div class="mt-4 px-4">
        <a @click="maas_top_url()" class="button-secondary block button-icon icon-left icon-round">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>{{ $t('tour_maas_top_link') }}</span>
        </a>
      </div>
    </div>
    <div v-show="showMapPanel" class="relative z-10">
      <map-detail @closeMap="closeMap"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CourseDetail from '../components/molecules/CourseDetail'
import MapDetail from "../components/molecules/MapDetail"

export default {
  name: 'ModelCourse',
  components: {
    CourseDetail,
    MapDetail
  },
  data () {
    return {
      areaId: null,
      areaDetail: null,
      courseId: null,
      course: null,
      showMapPanel: false
    }
  },
  created () {
    if (this.$route.params.areaId !== undefined) {
      this.areaId = this.$route.params.areaId
    }
    if (this.$route.query.area !== undefined) {
      this.areaDetail = this.$route.query.area
    }
    if (this.$route.query.course !== undefined) {
      this.courseId = this.$route.query.course
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('courses/fetchCourseDetail', this.$route.query.course)
        .then(() => {
          this.$store.dispatch('loading/endLoading')
          if (this.courseId !== null) {
            this.selectCourse(this.courseDetail)
          }
        })
    }
  },
  methods: {
    selectCourse: function (course) {
      this.course = course
      this.$refs['modelCourseTop'].scrollIntoView({ behavior: 'smooth'})
    },
    closeCourse: function () {
      this.course = null
      if (this.areaDetail === null) {
        this.$refs['modelCourseTop'].scrollIntoView({ behavior: 'smooth'})
      }
    },
    openMap: function () {
      this.showMapPanel = true
    },
    closeMap: function () {
      this.showMapPanel = false
    },
    maas_top_url: function () {
      this.$router.push( {name: 'top', query: { lang: this.lang } })
    }
  },
  computed: {
    ...mapGetters({
      courses: 'courses/getAll',
      courseDetail: 'courses/getCourseDetail'
    })
  }
}
</script>
